import {
	TQL_PRIVACY_POLICY_URL,
	TQL_TERMS_URL,
} from "~/shared/constants/legal-links.ts";

type ConsentStatementProps = {
	/** The label of the action button this consent statement is tied to (e.g. "Save"). */
	actionLabel: string;
};

/**
 * Consent statement displayed above an action button, dynamically referencing
 * that button's label. Links to TQL's Terms of Use and Privacy and Cookie Policy
 * open in a new browser tab.
 */
export const ConsentStatement = ({ actionLabel }: ConsentStatementProps) => {
	return (
		<p data-testid={"consent-statement"}>
			By clicking &quot;{actionLabel}&quot;, you agree and consent to TQL&apos;s{" "}
			<a
				className={"tql-link"}
				href={TQL_TERMS_URL}
				rel={"noreferrer"}
				target={"_blank"}
			>
				Terms of Use
			</a>{" "}
			and{" "}
			<a
				className={"tql-link"}
				href={TQL_PRIVACY_POLICY_URL}
				rel={"noreferrer"}
				target={"_blank"}
			>
				Privacy and Cookie Policy
			</a>
			.
		</p>
	);
};
